import { KeyframeTrack, KeyframeTrackData } from './KeyframeTrack';

/**
 * A Track of vectored keyframe values.
 */
export class VectorKeyframeTrack extends KeyframeTrack {
  ValueTypeName = 'vector';

  constructor(
    name: string,
    times: Array<number>,
    values: Array<any>,
    interpolation?: number,
  ) {
    super(name, times, values, interpolation);
  }

  static parse(json: KeyframeTrackData): KeyframeTrack {
    return new VectorKeyframeTrack(
      json.name,
      json.times,
      json.values,
      json.interpolation,
    );
  }
}
